// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__2vvD3","cta":"Details_cta__T7RkO","title":"Details_title__3TrwG"};